const Menu = [
	{
		heading: 'Main Navigation',
		translate: 'sidebar.heading.HEADER',
	},
	{
		name: 'Dashboard',
		translate: 'sidebar.nav.SUBMENU',
		path: '/dashboard',
		icon: 'icon-grid',
		permissions: ['admin', 'hubAdmin'],
	},
	{
		name: 'Manage Community',
		translate: 'sidebar.nav.SUBMENU',
		path: '/community-setup',
		icon: 'icon-cup',
		permissions: ['admin', 'Manage Community', 'community-setup'],
		// submenu: [
		// {
		//   name: "Religion",
		//   path: "/religion",
		// },
		// {
		//   name: "Native Place(state)",
		//   path: "/native-place",
		// },
		// {
		//   name: "Mother Tounge(Language)",
		//   path: "/language",
		// },
		// {
		//   name: "Caste",
		//   path: "/caste",
		// },
		// {
		//   name: "Community Setup",
		//   path: "/community-setup",
		//   permissions: ["community"],
		// },
		// {
		//   name: "Community & Caste Requested",
		//   path: "/hub-requested",
		// },
		// ],
	},
	{
		name: 'Users',
		translate: 'sidebar.nav.SUBMENU',
		path: '/user',
		icon: 'icon-people',
		permissions: ['admin', 'user'],
	},
	{
		name: 'Sanstha',
		translate: 'sidebar.nav.SUBMENU',
		path: '/sanstha',
		icon: 'icon-list',
		permissions: ['admin', 'sanstha'],
	},
	{
		name: 'Sponsors and Advertisements',
		translate: 'sidebar.nav.SUBMENU',
		path: '/sponsor',
		icon: 'icon-layers',
		permissions: ['admin', 'sponsor'],
	},
	{
		name: 'Posts',
		translate: 'sidebar.nav.SUBMENU',
		path: '/post',
		icon: 'icon-list',
		permissions: ['admin', 'post'],
	},
	{
		name: 'Social Project',
		path: '',
		icon: 'icon-list',
		permissions: ['admin', 'Social Project', 'project-category'],
		submenu: [
			{
				name: 'Social project category',
				path: '/project-category',
				permissions: ['admin', 'Social Project', 'project-category'],
			},
			{
				name: 'Social project',
				path: '/social-project',
				permissions: ['admin', 'Social Project', 'project-category'],
			},
		],
	},
	{
		name: 'Events',
		translate: 'sidebar.nav.SUBMENU',
		path: '/event',
		icon: 'icon-layers',
		permissions: ['admin', 'event'],
	},
	{
		name: 'Fundraising (Donation)',
		path: '/fundraising',
		icon: 'icon-cup',
		permissions: ['admin', 'Fundraising (Donation)', 'facility-booking'],
		submenu: [
			{
				name: 'Facility Booking',
				path: '/facility-booking',
				permissions: ['admin', 'facility-booking'],
			},
			{
				name: 'Contribution',
				path: '/contribution',
				permissions: ['admin', 'Fundraising (Donation)', 'facility-booking'],
			},
			{
				name: 'Membership contribution approval',
				path: '/requsteduser',
				permissions: ['admin', 'Fundraising (Donation)', 'facility-booking'],
			},
			{
				name: 'Social Project Donation',
				path: '/socialproject-donation',
				permissions: ['admin', 'Fundraising (Donation)', 'facility-booking'],
			},
			{
				name: 'Boli Booking',
				path: '/boli-booking',
				permissions: ['admin', 'Fundraising (Donation)', 'facility-booking'],
			},
			{
				name: 'Event Booking',
				path: '/event-booking',
				permissions: ['admin', 'Fundraising (Donation)', 'facility-booking'],
			},
			//    {
			//     name: "Apna Mandal Portal",
			//     path: "/apna-mandal",
			//    permissions: ['admin', 'Fundraising (Donation)', 'facility-booking'],
			//   },
		],
	},
	{
		name: 'Payment History',
		translate: 'sidebar.nav.SUBMENU',
		path: '/payment-history',
		icon: 'icon-cup',
		permissions: ['admin', 'Payment History', 'facility-booking'],
	},
	{
		name: 'Teams',
		translate: 'sidebar.nav.SUBMENU',
		path: '/teams',
		icon: 'icon-speedometer',
		permissions: ['admin', 'teams'],
	},
	// {
	//   name: "Payment Settings",
	//   translate: "sidebar.nav.SUBMENU",
	//   path: "/payment",
	//   icon: "icon-cup",
	//   permissions: ["admin", "payment"]
	// },
	// {
	//   name: "Compliance Date",
	//   translate: "sidebar.nav.SUBMENU",
	//   path: "/compliance",
	//   icon: "icon-layers",
	//   permissions: ["admin", "compliance"]
	// },
	// {
	//   name: "Faq",
	//   translate: "sidebar.nav.SUBMENU",
	//   path: "/faq",
	//   icon: "icon-grid",
	//   permissions: ["admin", "faq"]
	// },
	// {
	//   name: "Support",
	//   translate: "sidebar.nav.SUBMENU",
	//   path: "/support",
	//   icon: "icon-cup",
	//   permissions: ["admin", "support"]
	// },
	{
		name: 'Help Center',
		translate: 'sidebar.nav.SUBMENU',
		path: '/help',
		icon: 'icon-grid',
		permissions: ['admin', 'help'],
	},
	{
		name: 'Announcement',
		translate: 'sidebar.nav.SUBMENU',
		path: '/announcement',
		icon: 'icon-people',
		permissions: ['admin', 'announcement'],
	},
	// {
	//   name: "Payment Gateways",
	//   translate: "sidebar.nav.SUBMENU",
	//   path: "/payment",
	//   icon: "icon-grid",
	//   permissions: ["admin", "payment"]
	// },
	// {
	//   name: "Plans & Offers",
	//   translate: "sidebar.nav.SUBMENU",
	//   path: "/offer",
	//   icon: "icon-speedometer",
	//   permissions: ["admin", "offer"]
	// },
	// {
	//   name: "Products",
	//   path: "/admin/products",
	//   icon: "icon-grid",
	//   translate: "sidebar.nav.SINGLEVIEW",
	//   submenu: [
	//     {
	//       name: "Categories",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/categories/1",
	//     },
	//     {
	//       name: "Sub Categories",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/subcategories",
	//     },
	//     {
	//       name: "Products",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/products/1",
	//     },
	//     {
	//       name: "Choices & Addons",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/option-group",
	//     },
	//   ],
	// },
	// {
	//   name: "Users",
	//   translate: "sidebar.nav.MENU",
	//   path: "/admin/users/1",
	//   icon: "icon-people",
	//   submenu: [
	//     {
	//       name: "Customer",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/users/1",
	//     },
	//     {
	//       name: "Kitchen Staff",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/restaurant-user/1",
	//     },
	//   ],
	// },
	// {
	//   name: "Orders",
	//   translate: "sidebar.nav.SUBMENU",
	//   path: "/admin/orders/1",
	//   icon: "icon-list",
	// },
	// {
	//   name: "Configurations",
	//   path: "/admin/configuration",
	//   icon: "icon-speedometer",
	//   translate: "sidebar.nav.MENU",
	//   submenu: [
	//     {
	//       name: "Coupons",
	//       translate: "sidebar.nav.MENU",
	//       path: "/admin/coupons",
	//     },
	//     {
	//       name: "Delivery Time Selector",
	//       translate: "sidebar.nav.MENU",
	//       path: "/admin/delivery-time-selector",
	//     },
	//     {
	//       name: "General Settings",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/general-settings",
	//     },
	//     {
	//       name: "Taxes",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/taxes",
	//     },
	//     {
	//       name: "Pickup Address",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/pickup",
	//     },
	//     {
	//       name: "Delivery Estimate",
	//       translate: "sidebar.nav.SUBMENU",
	//       path: "/admin/delivery_estimate/1",
	//     },
	//   ],
	// },
]

export default Menu
